import { Theme, alpha } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

import { UiAlpha } from '../../../styles/ui-alpha';

export const useLeadBlockStyles = makeStyles<Theme>()((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
  },
  titleRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: theme.spacing(1),
    width: '100%',
  },
  title: {
    margin: 0,
    flex: 1,
    minWidth: 0,
  },
  titleEnd: {
    flexShrink: 0,
    marginTop: theme.spacing(0.25),
  },
  paragraphRow: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1.5),
    padding: theme.spacing(2),
    borderRadius: 10,
    border: `1px solid ${theme.palette.primary.main}`,
    backgroundColor: alpha(theme.palette.primary.main, UiAlpha.Subtle),
  },
  iconWrap: {
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: theme.spacing(0.25),
    color: theme.palette.primary.main,
  },
  icon: {
    width: 24,
    height: 24,
    display: 'block',
  },
  paragraph: {
    flex: 1,
    minWidth: 0,
    margin: 0,
  },
}));
